module.exports = __webpack_public_path__ + "img/bg_register_agency_small.218c12bd.jpg";